import React, { useEffect, useState } from "react";
// import "./LiveHeader.module.scss";
import { fit } from "../../utils";

export interface LiveHeaderProps {
  avatar: string;
  display_name: string;
  phone: string;
}

const LiveHeader = (props: LiveHeaderProps) => {
  const [hideHeader, sethideHeader] = useState<boolean>(false);

  useEffect(() => {
    document.body.classList.add("no-scroll");

    return () => {
      document.body.classList.remove("no-scroll");
    };
  });

  const hideToggle: React.CSSProperties = {
    position: "fixed",
    zIndex: 99999,
    right: "10px",
    top: "19px",
    height: "10px",
    aspectRatio: "1",
    borderRadius: "5px",
    border: "none",
    margin: 0,
    padding: 0,
    backgroundColor: "#ffffff09",
    boxShadow: "0 0 10px #00000050",
  };

  return (
    <>
      <button
        onClick={() => sethideHeader((hideHeader) => !hideHeader)}
        // className='hideToggle'
        style={hideToggle}
      />

      <header
        className='board-header board-header--open'
        style={{ display: hideHeader && "none" }}
      >
        <div className='board-header-bg'></div>

        <div className='board-header-pic board-header-pic--open'>
          <img
            src={props.avatar}
            className='board-header-pic-img board-header-pic-img--open'
          />
        </div>

        <div
          ref={fit}
          className='board-header-name board-header-name--open'
        >
          {props.display_name}
        </div>

        <div className='board-header-phone'>
          <span className='board-header-instructions'>
            Text Photos &amp; Messages to
          </span>
          <span className='board-header-number'> {props.phone}</span>
        </div>
      </header>
    </>
  );
};

export default LiveHeader;
